/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

// TODO Set the correct article ID here
const ARTICLE_ID = '738442417325'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Diese Regeln gelten für den Tourismus in den Kantonen</h1>
            <h2>
              In der Waadt sind die Skihütten offen, in Graubünden gibts bald
              wieder Kafi Schnaps auf der Sonnenterrasse – und in Luzern bleibt
              Skifahren verboten. Ein Überblick über die kantonalen Regeln.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Angela Barandun, Andreas Moor</div>
          </div>
          <div className='ta text'>
            Wer einen Skiausflug oder Ferien in der Schweiz plant, sollte sich
            zuerst über die Corona-Vorschriften am Zielort informieren. Denn
            während im öffentlichen Verkehr landesweit einheitlich eine
            Maskenpflicht gilt, können die Vorschriften für Freizeitbetriebe in
            den Kantonen abweichen. Die Regeln werden je nach Entwicklung der
            Pandemie in den einzelnen Regionen angepasst.
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div style={{ maxWidth: 800, margin: 'auto', padding: 15 }}>
          <AutofitIFrame src='https://datawrapper.dwcdn.net/tOnyg/' />
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die grössten Unterschiede gibt es aktuell in den Skigebieten. In
              der Waadt und im Wallis waren anfangs noch alle Restaurants
              geöffnet, seit dem 26. Dezember sind sie in beiden Kantonen
              geschlossen. In der Waadt gelten in den Wintersportorten
              allerdings Erleichterungen, dort sind Cafés, Restaurants und Bars
              auf Skipisten geöffnet, solange die Bergbahnen in Betrieb sind.
              Auch im Freizeitbereich weichen die waadtländer Regeln ab: Museen
              und Kunstgalerien dürfen offen bleiben, alles andere - also Kinos,
              Fitnesscenter, Schwimmbäder etc. - sind zu.{' '}
            </p>

            <p>
              Die Verpflegung auf der Piste wird ab sofort auch für
              Wintersportler in Graubünden und im Kanton Uri einfacher: Beide
              Kantone haben verfügt, dass die Gäste in Skihütten mit
              Take-Away-Angebot ab sofort auch wieder auf der Terrasse sitzen
              und die Toiletten im Innenraum benutzen können. Zudem heben beide
              Kantone per 4. Januar das Alkoholverbot auf den Pisten auf.{' '}
            </p>

            <p>
              Zu den Kantonen, die in den letzten Tagen entschieden haben, ihre
              Skigebiete wieder zu öffnen, gehört etwa der Kanton St. Gallen. In
              den Wintersportgebieten Flumserberge, Bad Ragaz-Pizol und
              Wildhaus-Chäserrugg wird ab sofort wieder Ski gefahren. Auch die
              beiden Appenzell, Glarus, Ob- und Nidwalden sowie Zug haben ihre
              Pisten kurz vor Silvester wieder geöffnet.{' '}
            </p>

            <p>
              Anders sieht es im Kanton Schwyz und in Luzern aus: Dort wurde in
              den letzten Tagen entschieden, dass die Skigebiete noch bis
              mindestens am 8. Januar geschlossen bleiben.
            </p>
          </div>
        </div>
      </div>

      <Footer articleId={ARTICLE_ID} credits={[]} hideUserFeedback />
    </div>
  )
}
